import Container from '@mui/material/Container';
import { Orders } from '../features/orders';
import { PAGES_ANALYTICS_TITLES } from '../utils/enums';
import { PageHelmet } from '../components';

const OrdersPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.ORDERS}>
    <Container
      sx={{
        px: { xs: 0, lg: 2 },
      }}
      maxWidth={false}
    >
      <Orders />
    </Container>
  </PageHelmet>
);

export default OrdersPage;
